import { InfoCircleFilled } from "@ant-design/icons";

import styles from "./style.module.css";

export function RoleInfoButton({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" className={styles.infoButton} onClick={onClick} aria-label="View role definitions">
      <InfoCircleFilled className={styles.infoIcon} />
    </button>
  );
}
